import type { FC, ReactNode } from 'react';

import useStyles from './AuthTileFooter.styles';

type Props = {
  children: ReactNode;
};

const AuthTileFooter: FC<Props> = ({ children }) => {
  const { classes } = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export default AuthTileFooter;
